import { FlexContainer } from "../Flex";
import { Text } from "../Text";

interface TimelineImageLabelProps {
  year: string;
  label: string;
  align: "start" | "end";
}

export const TimelineImageLabel: React.FC<TimelineImageLabelProps> = ({
  year,
  label,
  align = "start",
}) => {
  return (
    <FlexContainer
      justifyContent={align === "start" ? "flex-start" : "flex-end"}
      mx={-1}
    >
      <Text
        variant="small"
        as="span"
        fontWeight={700}
        px={1}
        lineHeight="1.75em"
      >
        {year}
      </Text>
      <Text variant="small" as="span" px={1} lineHeight="1.75em">
        {label}
      </Text>
    </FlexContainer>
  );
};
